import { ModalConfirmConfig } from "Components/General/Modal/ModalContext";
import { I18N_NS } from "Config/i18n";
import { TFunction } from "i18next";

export const getBimModalConfirmConfig = (t: TFunction): ModalConfirmConfig => ({
  title: t("There are unsaved changes in this issue.", { ns: I18N_NS.GENERAL }),
  content: t("Do you want to save them?", { ns: I18N_NS.GENERAL }),
  okText: t("Yes", { ns: I18N_NS.GENERAL }),
  cancelText: t("No, discard changes", { ns: I18N_NS.GENERAL }),
  closeOnCancel: true,
});
